import React, { useState } from "react";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const parse = (s) => (s ? new Date(s + "T00:00:00") : undefined);
const addMonths = (d, n) => { const x = new Date(d); x.setMonth(x.getMonth() - n); return x; };
const ddmmyyyy = (s) => (s ? format(parse(s), "dd/MM/yyyy") : "-");

const PRESETS = [["1m", "1 Bulan", 1], ["2m", "2 Bulan", 2], ["3m", "3 Bulan", 3], ["6m", "6 Bulan", 6], ["1y", "Tahunan", 12]];

export function rangeForPreset(key) {
  const today = new Date();
  const p = PRESETS.find((x) => x[0] === key);
  if (!p) return { from: iso(today), to: iso(today), preset: "daily" };
  return { from: iso(addMonths(today, p[2])), to: iso(today), preset: key };
}

export default function DateRangeFilter({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState({ from: parse(value.from), to: parse(value.to) });

  const apply = (r) => {
    setSel(r || {});
    if (r?.from) onChange({ from: iso(r.from), to: iso(r.to || r.from), preset: "daily" });
    if (r?.from && r?.to) setOpen(false);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button data-testid="drf-daily" className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-sm font-medium ${value.preset === "daily" ? "bg-primary text-white" : "bg-slate-100 text-slate-600"}`}>
            <CalendarDays size={14} /> Harian
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <div className="p-3 border-b border-slate-100 text-sm font-medium text-slate-700">
            {sel.from ? `${ddmmyyyy(iso(sel.from))}${sel.to ? ` – ${ddmmyyyy(iso(sel.to))}` : " – (pilih selesai)"}` : "Pilih tanggal mulai & selesai"}
          </div>
          <Calendar mode="range" numberOfMonths={2} selected={sel} onSelect={apply} disabled={{ after: new Date() }} defaultMonth={sel.from || new Date()} />
        </PopoverContent>
      </Popover>
      {PRESETS.map(([k, l]) => (
        <button key={k} onClick={() => onChange(rangeForPreset(k))} data-testid={`drf-${k}`} className={`px-3 h-9 rounded-full text-sm font-medium ${value.preset === k ? "bg-primary text-white" : "bg-slate-100 text-slate-600"}`}>{l}</button>
      ))}
      <span className="text-sm text-slate-500 font-medium ml-1" data-testid="drf-label">{ddmmyyyy(value.from)}{value.to && value.to !== value.from ? ` – ${ddmmyyyy(value.to)}` : ""}</span>
    </div>
  );
}
